import {forwardRef, Inject, Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./session.service";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {DlgErrorMessage} from "../common/DlgErrorMessage";
import {SafeHtml} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {AlertMessage} from "../directives/AlertMessage";
import {EmprezChatMessage} from "../home/chat/model/EmprezChatMessage";
import {DlgChatMessage} from "../common/DlgChatMessage";
import {ModalResult} from "../model/common.model";


@Injectable()
export class PopupServices {
  constructor(
              // @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
               @Inject(forwardRef(() => Router)) private router: Router,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
              @Inject(forwardRef(() => SessionService)) private session: SessionService
  )
  {

  }



  private _allModals = new Array<NgbModalRef>();
  registerModal(modalRef: NgbModalRef) {
    this._allModals.push(modalRef);
  }

  dismissAllModals(){
    for (const modal of this._allModals){
      if (modal){
        modal.dismiss();
      }
    }
  }

  private _createModalRef(placementHolder?: string){
    let modalRef = null;
    if (placementHolder && placementHolder.trim().length>0){
      modalRef = this.modalService.open(DlgErrorMessage,{container:placementHolder});
    }else{
      modalRef = this.modalService.open(DlgErrorMessage);
    }
    return modalRef;
  }

  public error(msg:string, errorCode:any, placementHolder?: string){
      this.errorMessage(msg,errorCode,placementHolder);
  }

    public errorMessage(msg:string, errorCode:any, placementHolder?: string){
    const modalRef = this._createModalRef(placementHolder);
      if (errorCode === 141414) {
        modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('SessionLostPleaseReconnect'));
      }else{
        modalRef.componentInstance.populate(this.translate.instant('Error'),msg);
      }
      modalRef.result.then((result) => {
        if (errorCode === 141414){
          this.session.close(true);
        }
      });
    }

  public errorMessageWithPromise(msg:string, errorCode:any, placementHolder?: string):Promise<any>{
    const modalRef = this._createModalRef(placementHolder);
    if (errorCode === 141414) {
      modalRef.componentInstance.populate(this.translate.instant('Error'),this.translate.instant('SessionLostPleaseReconnect'));
    }else{
      modalRef.componentInstance.populate(this.translate.instant('Error'),msg);
    }
    return modalRef.result;
  }




  public success(msg:string, placementHolder? :string){
      this.successMessage(msg,placementHolder);
  }

  public successMessage(msg:string, placementHolder? :string){
    const modalRef = this._createModalRef(placementHolder);
    modalRef.componentInstance.populate(this.translate.instant('Info'),msg,'emprez-vert-agrume');
    modalRef.result.then((result) => {
    });
  }


  public chat(msg:EmprezChatMessage, placementHolder? :string){
    this.chatMessage(msg,placementHolder);
  }

  public chatMessage(msg:EmprezChatMessage, placementHolder? :string){

    // const msg = new AlertMessage();
    // msg.type='chat';
    // msg.chatType = true;
    // const message = this.translate.instant('NewChatFrom',{body: msg.body, from: msg.fromName, channel: msg.channelName})
    const message = msg.fromName + ': \'' + msg.body + '\'';

    let modalRef = null;
    if (placementHolder && placementHolder.trim().length>0){
      modalRef = this.modalService.open(DlgChatMessage,{container:placementHolder});
    }else{
      modalRef = this.modalService.open(DlgChatMessage);
    }



    // const modalRef = this._createModalRef(placementHolder);
    modalRef.componentInstance.populate(msg.channelName,message,'emprez-vert-agrume');

  // public viewMessage(){
  //     this.router.navigate([this.session.homePath + '/chats'],{queryParams:{channelId:this.messageAsAlertMessage.chatChannelId}});
  //   }

    modalRef.result.then((result) => {
      console.log('Received ' + result);
      if (ModalResult.OTHER === result){
        this.router.navigate([this.session.homePath + '/chats'],{queryParams:{channelId:msg.chatChannelId}});
      }
    });
  }



  public successMessageWithPromise(msg:string,placementHolder?: string):Promise<any>{
    const modalRef = this._createModalRef(placementHolder);
    modalRef.componentInstance.populate(this.translate.instant('Info'),msg,'emprez-vert-agrume');
    return modalRef.result;
  }




  public successMessageWithTitle(title: string, msg:string, placementHolder? :string){
    const modalRef = this._createModalRef(placementHolder);
    modalRef.componentInstance.populate(title,msg,'emprez-vert-agrume');
    modalRef.result.then((result) => {
    });
  }


  public errorHtmlMessage(msg:SafeHtml, placementHolder? :string){
    const modalRef = this._createModalRef(placementHolder);

    // populate(title: string, msg: string, msgCls?: string, html?: SafeHtml, stackString?: string){
    //
    // }
    modalRef.componentInstance.populate(this.translate.instant('Error'),null,null,msg);
    modalRef.result.then((result) => {
    });
  }

}




/*

 */
